import { render } from "./IntroText.vue?vue&type=template&id=562ddbcd&scoped=true"
import script from "./IntroText.vue?vue&type=script&lang=js"
export * from "./IntroText.vue?vue&type=script&lang=js"

import "./IntroText.vue?vue&type=style&index=0&id=562ddbcd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562ddbcd"]])

export default __exports__